var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadcomponent = function SvgDownloadcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C7.705 1 1 7.705 1 16s6.705 15 15 15 15-6.705 15-15S24.295 1 16 1Z",
    fill: "current",
    stroke: "#A08264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.143 14.235H21l-5 4.942-5-4.942h2.857V10h4.286v4.235ZM11 22v-1.412h10V22H11Z",
    fill: "#A08264"
  })));
};
export default SvgDownloadcomponent;